
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Typography } from "@mui/material";
import MessageError from "../../../../messages/messageError";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../services/api";
import * as yup from 'yup'; // VALIDACAO
import ButtonLeft from "../../../../utils/buttonLeft";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";
import FazerObservacoes from "../../../components/fazerObservacoes.";


export default function ChangeStatusFarmacoviligancia({ setNotificacao }) {
    const { id, action,status } = useParams()
    const navigate = useNavigate()
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);
    const dispatch = useDispatch()


    const handleChangeStatus = () => {
        setOpen(true)
        api.patch("/farmaco-vigilancia/change-status", {
            status: status,
            farmacoVigilanciaId: id,
            userId: user?._id,
            observacao: obs
        }).then(response => {

            dispatch({
                type: 'alert',
                payload: { alert: 'notificação encaminhada com sucesso.!' },
            });
            // console.log(response.data);
            setNotificacao(response.data.farmacoVigilancia);
            navigate(localStorage.getItem('urlAnterior') || -1);
        }).catch(error => {
            setMessageError(error.response.data.message)
        }).finally(() => setOpen(false))
    }

    async function validate() {
        setMessageError('');

        let schema = yup.object().shape({
            observacao: yup.string("Necessário inserir as observações").required("Necessário inserir observações"),
        })

        try {
            await schema.validate({ 'observacao': obs })
            handleChangeStatus()
        } catch (error) {
            setMessageError(error.errors);
        }
        return false
    }


    return (
        <Card style={{ padding: 20, paddingBottom: 30 }}>
            {messageError && <MessageError message={messageError} />}

            <div style={{ marginBottom: 30 }}>

                <HeaderGestorConfigs title={`Confirmação de  ${action === 'repprove' ? ' reprovação ' : ' aprovação'}`} />

                {action !== 'repprove' &&
                    <Typography >
                        Ao confirmar esta ação estarás a afirmar que análisaste correctamente
                        toda informação e documentos anexado neste processo estão em conformidade!
                    </Typography>
                }

                <FazerObservacoes setObs={setObs} obs={obs} titulo={action === 'approve' ? '(caso seja necessário fazer alguma observação)' : '(Descreve os motivos desta reprovação)'} />

                <ButtonLeft
                    funcao={action === 'approve' ? handleChangeStatus : validate}
                    title={'Confirmar'}
                    load={open}
                >
                    <Button color="error" onClick={() => navigate(`/admin/farmacovigilancia/view/notificacao/${id}`)} >Cancelar</Button>
                </ButtonLeft>
            </div>
        </Card>
    )
}